<template>
  <v-container>
    <v-data-table v-if="authPermissions.has('exports:view')" :items="items" hide-default-header hide-default-footer
      :items-per-page="items.length">
      <template v-slot:item="{ item, index }">
        <tr>
          <td>{{ item.name }}</td>
          <td>{{ item.quantity }} Not Exported</td>
          <td>
            <v-tooltip bottom v-if="authPermissions.has('exports:export')">
              <template v-slot:activator="{ on, attrs }">
                <v-btn class="mx-2" fab dark small v-bind="attrs" v-on="on" color="red" :loading="uploading"
                  @click="download(index)">
                  <v-icon dark>mdi-package-down</v-icon>
                </v-btn>
              </template>
              <span>Export</span>
            </v-tooltip>
            <v-tooltip bottom v-if="authPermissions.has('exports:import')">
              <template v-slot:activator="{ on, attrs }">
                <v-btn class="mx-2" fab dark small v-bind="attrs" v-on="on" color="green" @click="upload(index)">
                  <v-icon dark>mdi-package-up</v-icon>
                </v-btn>
              </template>
              <span>Import</span>
            </v-tooltip>
          </td>
        </tr>
      </template>
    </v-data-table>
    <v-dialog dismissable max-width="600px" v-model="uploadSuccess" eager class="pa-0">
      <v-card>
        <v-toolbar color="green" dark>
          <v-card-title class="pa-0">{{ successAlertTitle }}</v-card-title>
        </v-toolbar>
        <v-card-text>{{ successAlertBody }}</v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog dismissable max-width="600px" v-model="uploadError" eager class="pa-0">
      <v-card>
        <v-toolbar color="red" dark>
          <v-card-title class="pa-0">{{ errorTitle }}</v-card-title>
        </v-toolbar>
        <v-card-text>{{ error }}</v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>
<script>
import CLIRepository from '@/repositories/consumer-loan-inventory.repository'
import CLTRepository from '@/repositories/consumer-loan-transaction.repository'
import CLRepository from '@/repositories/consumer-loan.repository'
import consumerRepository from '@/repositories/consumer.repository'
import LIRepository from '@/repositories/lost-inventory.repository'
import SIRepository from '@/repositories/sale-inventory.repository'
import RIRepository from '@/repositories/recieved-inventory.repository'
import SPRepository from '@/repositories/supplier-product.repository'
import supplierRepository from '@/repositories/supplier.repository'
import stockRepository from '@/repositories/stock.repository'
import unitRepository from '@/repositories/unit.repository'
import fs from 'fs'
import { mapState } from 'vuex'

const { dialog } = require('electron').remote

function exportReps(index) {
  let ret
  let tableName = ''
  const timestampCols = [
    'deleted_at',
    'updated_at',
  ]
  const timeStamp = Date.now()
  let columns = []
  let uniqueIdentifier = []
  switch (index) {
    case 0:
      ret = CLIRepository
      tableName = 'consumer_loan_inventories'
      columns = [
        'supplier_id',
        'stock_id',
        'unit',
        'retail',
        'quantity',
      ]
      uniqueIdentifier = [
        'id',
      ]
      break
    case 1:
      ret = CLTRepository
      tableName = 'consumer_loan_transactions'
      columns = [
        'payer_name',
        'amount_paid',
        'date_transaction',
      ]
      uniqueIdentifier = [
        'id',
      ]
      break
    case 2:
      ret = CLRepository
      tableName = 'consumer_loans'
      columns = [
        'loanee_name',
        'date_loaned',
      ]
      uniqueIdentifier = [
        'id',
        'consumer_id',
      ]
      break
    case 3:
      ret = consumerRepository
      tableName = 'consumers'
      columns = [
        'name',
        'address',
        'contact_no_1',
        'contact_no_2',
      ]
      uniqueIdentifier = [
        'id',
      ]
      break
    case 4:
      ret = LIRepository
      tableName = 'lost_inventories'
      columns = [
        'supplier_id',
        'stock_id',
        'unit',
        'cost',
        'quantity',
        'notes',
        'date_lost',
      ]
      uniqueIdentifier = [
        'index_key',
      ]
      break
    case 5:
      ret = RIRepository
      tableName = 'purchased_inventories'
      columns = [
        'supplier_id',
        'stock_id',
        'unit',
        'cost',
        'quantity',
        'date_recieved',
      ]
      uniqueIdentifier = [
        'index_key',
      ]
      break
    case 6:
      ret = SIRepository
      tableName = 'sold_inventories'
      columns = [
        'supplier_id',
        'stock_id',
        'unit',
        'retail',
        'quantity',
        'date_sold',
      ]
      uniqueIdentifier = [
        'index_key',
      ]
      break
    case 7:
      ret = stockRepository
      tableName = 'stocks'
      columns = [
        'product_name',
        'brand_name',
        'description',
        'retail',
        'unit',
      ]
      uniqueIdentifier = [
        'id',
      ]
      break
    case 8:
      ret = supplierRepository
      tableName = 'suppliers'
      columns = [
        'name',
        'subscription_date',
        'address',
        'contact_no_1',
        'contact_no_2',
        'active',
      ]
      uniqueIdentifier = [
        'id',
      ]
      break
    case 9:
      ret = SPRepository
      tableName = 'supplier_products'
      columns = [
        'cost',
        'unit',
      ]
      uniqueIdentifier = [
        'supplier_id',
        'stock_id',
      ]
      break
    case 10:
      ret = unitRepository
      tableName = 'units'
      columns = [
        'description',
      ]
      uniqueIdentifier = [
        'unit',
      ]
      break
  }
  return {
    repository: ret,
    tableName: tableName,
    fileName: `${tableName}_${timeStamp}`,
    columns: columns.concat(timestampCols),
    uniqueIdentifier,
  }
}

export default {
  name: 'export',
  data() {
    return {
      items: [
        { name: 'Loans Items', quantity: 0 },
        { name: 'Loans Paid', quantity: 0 },
        { name: 'Loans Taken', quantity: 0 },
        { name: 'Consumer', quantity: 0 },
        { name: 'Lost Inventory', quantity: 0 },
        { name: 'Purchased Inventory', quantity: 0 },
        { name: 'Sold Inventory', quantity: 0 },
        { name: 'Stocks', quantity: 0 },
        { name: 'Suppliers', quantity: 0 },
        { name: 'Supplier Products' },
        { name: 'Units', quantity: 0 },
      ],
      downloading: false,
      uploading: false,
      uploadSuccess: false,
      uploadError: false,
      error: null,
      successAlertTitle: null,
      successAlertBody: null,
      errorTitle: null,
    }
  },
  computed: {
    ...mapState({
      authPermissions: state => state.auth.userPermissions,
    }),
  },
  methods: {
    upload(index) {
      if (!this.uploading) {
        let mainWindow
        const { repository, tableName, columns, uniqueIdentifier } = exportReps(index)
        const options = {
          title: 'Import',
          filters: [{ name: 'Inventory Rush', extensions: ['ir'] }],
          buttonLabel: 'import',
        }
        dialog.showOpenDialog(mainWindow, options)
          .then(this.openFile(tableName, columns, uniqueIdentifier, repository))
      }
    },
    download(index) {
      const { repository, fileName, tableName } = exportReps(index)
      repository.export()
        .then(this.exportData(fileName, tableName))
        .catch(e => { })
        .then(() => { this.downloading = false })
    },
    exportData(fileName, tableName) {
      let mainWindow
      return ({ data }) => {
        const options = {
          title: 'Export',
          defaultPath: `~/${fileName}.ir`,
          filters: [{ name: 'Inventory Rush', extensions: ['ir'] }],
          buttonLabel: 'export',
        }
        dialog.showSaveDialog(mainWindow, options)
          .then(this.saveFile(data, tableName))
      }
    },
    openFile(nTableName, columns, unique, repository) {
      return ({ filePaths, canceled }) => {
        if (!canceled) {
          const file = fs.readFileSync(filePaths[0], 'utf8', err => {
            this.errorTitle = 'Problem Importing!'
            this.error = err.toString()
          })
          const { tableName, data } = JSON.parse(atob(file))
          if (nTableName !== tableName) {
            const tn1 = nTableName.replace('_', ' ')
            const tn2 = tableName.replace('_', ' ')
            this.uploadError = true
            this.error = `Error: Data in ${tn2} is not inteded for ${tn1}!`
          } else {
            this.uploading = true
            repository.import({ data, columns, unique })
              .then(this.initUploadSuccess(tableName))
              .catch((e) => {
                // console.log(JSON.stringify({ data, columns, unique }))
                this.uploadError = true
                this.error = e.toString()
              })
              .then(() => { this.uploading = false })
          }
        }
      }
    },
    initUploadSuccess(tableName) {
      this.uploadSuccess = true
      this.successAlertTitle = 'Import Success!'
      this.successAlertBody = `The ${tableName.replace('_', ' ')} upload was successful!`
    },
    initDownloadSuccess(tableName) {
      this.uploadSuccess = true
      this.successAlertTitle = 'Export Success!'
      this.successAlertBody = `The ${tableName.replace('_', ' ')} export was successful!`
    },
    saveFile(data, tableName) {
      return ({ filePath, canceled }) => {
        if (!canceled) {
          const info = JSON.stringify({ tableName, data })
          fs.writeFileSync(filePath, btoa(info), { encoding: 'utf8' }, err => {
            this.uploadError = true
            this.errorTitle = 'Problem Exporting!'
            this.error = err.toString()
          })
          if (!this.uploadError) {
            this.initDownloadSuccess(tableName)
          }
        }
      }
    },
  },
}
</script>
